<div class="container my-4">
    <div class="row">
        <div class="col-12 text-right mb-2">
            <label *ngIf="lastUpdatedDate" style="color:crimson; font-size:15px;font-weight:bold;">
                Last Updated On :</label>
            <label class="ml-2" style="font-weight:bold;color:crimson;">{{lastUpdatedDate |
                date:'dd/MM/yyyy'}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">Balance Details</span>
        </div>
    </div>
    <div class="row justify-center">
        <div class="col-sm-12">
            <div class="card-boxtotalbalance pt-2 pb-3 mt-0 text-center"
                style="border-top-right-radius: 0px;border-top-left-radius: 0px;border-bottom-right-radius: 10px;border-bottom-left-radius: 10px;">
                <img class="my-2" src="assets/images/PaymentDashboard icons/total-balance-customers.png" width="60px"
                    height="60px">
                <div class="inner">
                    <h3>{{cardData?.BilableCustomerCount}} </h3>
                    <p class="pb-3"> Total Balance Customer </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/Debit-day-1st.svg" width="60px" height="60px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.Debit1st}} </h4>
                    <p> Debit 1st </p>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/Debit-day-15th.svg" width="60px" height="60px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.Debit15th}} </h4>
                    <p> Debit 15th </p>
                </div>

            </div>
        </div>
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/Debit-day-25th.svg" width="60px" height="60px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.Debit25th}} </h4>
                    <p> Debit 25th </p>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/EFT-Balance.svg" width="60px" height="60px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.EFT}} </h4>
                    <p> EFT </p>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-4">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/Total-balance.svg" width="70px" height="80px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.TotalBalance}} </h4>
                    <p> Total Balance </p>
                </div>
            </div>
        </div>
        <div class="col-xl-4">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/Collections.svg" width="65px" height="70px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.Collection}} </h4>
                    <p> Collections Balance </p>
                </div>
            </div>
        </div>
        <div class="col-xl-4">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <img src="assets/images/PaymentDashboard icons/Reseller.svg" width="65px" height="70px">
                </span>
                <div class="inner">
                    <h4>{{cardData?.Reseller}} </h4>
                    <p> Reseller Balance </p>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <span class="title_header_bar">Top 50 Customers With Balance</span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card-boxtotalbalance py-4 mt-0">
                <div id="chart">
                    <apx-chart [series]="barChatOptions?.series" [chart]="barChatOptions?.chart"
                        [dataLabels]="barChatOptions?.dataLabels" [stroke]="barChatOptions?.stroke"
                        [colors]="barChatOptions?.colors" [title]="barChatOptions?.title"
                        [plotOptions]="barChatOptions?.plotOptions" [yaxis]="barChatOptions?.yaxis"
                        [xaxis]="barChatOptions?.xaxis" [tooltip]="barChatOptions?.tooltip"
                        [legend]="barChatOptions?.legend"></apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <span class="title_header_bar">Province Wise Customers Balance</span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card-boxtotalbalance py-4 mt-0">
                <div id="chart2">
                    <apx-chart [series]="donutOptions?.series" [chart]="donutOptions?.chart"
                        [labels]="donutOptions?.labels" [tooltip]="donutOptions?.tooltip" [fill]="donutOptions?.fill"
                        [plotOptions]="donutOptions?.plotOptions" [colors]="donutOptions?.colors"
                        [dataLabels]="donutOptions?.dataLabels" [legend]="donutOptions?.legend"
                        [responsive]="donutOptions?.responsive">
                    </apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <span class="title_header_bar">Customers Balance Range Wise</span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card-boxtotalbalance py-4 mt-0">
                <div id="treechart">
                    <apx-chart [series]="areaChartOptions?.series" [chart]="areaChartOptions?.chart"
                        [dataLabels]="areaChartOptions?.dataLabels" [stroke]="areaChartOptions?.stroke"
                        [colors]="areaChartOptions?.colors" [title]="areaChartOptions?.title"
                        [plotOptions]="areaChartOptions?.plotOptions" [yaxis]="areaChartOptions?.yaxis"
                        [xaxis]="areaChartOptions?.xaxis" [tooltip]="areaChartOptions?.tooltip"
                        [legend]="areaChartOptions?.legend"></apx-chart>
                </div>
            </div>
        </div>
    </div>
</div>
